import React, { useState } from "react";

import {
  Button,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";

import BlockUi from "react-block-ui";
import Loader from "react-loaders";

export const EVENTS = {
  CANCEL: "CANCEL",
  ADD: "ADD",
};

const AddGroupRodal = (props) => {
  const isOpen = props.isOpen || false;
  const emitAction = props.emitAction;

  const [addGroupName, setAddGroupName] = useState(null);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        emitAction(EVENTS.CANCEL);
      }}
      animation={"flip"}
      width={640}
    >
      <BlockUi
        tag="div"
        className="block-overlay-dark"
        loader={
          <Loader color="#ffffff" active type={"ball-spin-fade-loader"} />
        }
      >
        <ModalHeader>Add Group</ModalHeader>
        <ModalBody className="pb-0">
          <FormGroup className="mt-4">
            <Input
              type="text"
              placeholder="Please input group name"
              value={addGroupName || ""}
              onChange={(e) => setAddGroupName(e.target.value)}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              emitAction(EVENTS.CANCEL);
            }}
          >
            Cancel
          </Button>
          <Button
            color="info"
            onClick={() => {
              emitAction(EVENTS.ADD, {name: addGroupName});
            }}
          >
            Add
          </Button>
        </ModalFooter>
      </BlockUi>
    </Modal>
  );
};

export default AddGroupRodal;
